import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives';
import ProgressBar from '@atlaskit/progress-bar';

export interface ChecklistProgressBarProps {
	ariaLabel?: string;
	isIndeterminate?: boolean;
	value: number;
}

export default ({ value = 0, isIndeterminate = false, ariaLabel }: ChecklistProgressBarProps) => {
	return (
		<Box backgroundColor="elevation.surface.raised" padding="space.250">
			<ProgressBar ariaLabel={ariaLabel} value={value} isIndeterminate={isIndeterminate} />
		</Box>
	);
};
